import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { HelpDialogComponent } from '../../pages/help-dialog/help-dialog.component';

interface HelpData {
  [key: string]: {
    description: string;
    content: string;
  };
}

@Component({
  selector: 'app-mount-point-popup',
  templateUrl: './mount-point-popup.component.html',
  styleUrl: './mount-point-popup.component.scss'
})
export class MountPointPopupComponent implements OnInit {
  selectedMountPoint: any;
  action: string = '';
  loading = true;
  canEdit = true;
  helpData: HelpData = {
    type: {
      description: 'Indicator of a stream description',
      content: 'Content: STR'
    },
    mountpoint: {
      description: 'Mountpoint name. Must be unique across the system and can include up to 100 characters. Allowed characters are A-Z, a-z, 0-9, hyphens (-), underscores (_), and periods (.).',
      content: 'Text'
    },
    identifier: {
      description: 'Source identifier - usually use the name of the nearest city.',
      content: 'Text'
    },
    format: {
      description: 'Protocol used. For example: BINEX, CMR, NMEA, RAW, RTCA, RTCM 2.1, RTCM 2.2, RTCM 2.3, RTCM 3.0, RTCM 3.1, RTCM 3.2, RTCM 3.3',
      content: 'Text'
    },
    formatDetails: {
      description: 'Sentences used. For example: For example: 1005(1),1077(1),1087(1),1097(1),1127(1),1230(8)',
      content: 'Text'
    },
    carrier: {
      description: '0 - No phase information included; 1	- L1 phase included; 2 - L2 phase included.',
      content: 'Number'
    },
    navSystem: {
      description: 'Navigation System. For example: BDS, GAL, GLO, GPS, IRS, QZS, SBAS',
      content: 'Text'
    },
    network: {
      description: 'Network name: Typically, enter your organization name.',
      content: 'Text'
    },
    country: {
      description: 'Country of your RTK BaseStation location: Please use the ISO 3166 country code. For example: USA, CAN.',
      content: '3 characters'
    },
    latitude: {
      description: 'Latitude in degrees of your RTK BaseStation location.',
      content: 'Decimal number, two digits after dot'
    },
    longitude: {
      description: 'Longitude in degree of your RTK BaseStation location.',
      content: 'Decimal number, two digits after dot'
    },
    nmea: {
      description: 'Does this mountpoint require NMEA input? Yes -> 1; No -> 0.',
      content: '1 or 0'
    },
    solution: {
      description: 'RTK solution generated by? If single base -> 0; if network -> 1.',
      content: '1 or 0'
    },
    generator: {
      description: 'NTRIP correction data generated by what software or hardware',
      content: 'Text'
    },
    compression: {
      description: 'What compression algorithm is used?',
      content: 'Text'
    },
    authentication: {
      description: 'what Access protection is used for the data streams? None -> N, Basic -> B, Digest ->D',
      content: 'N, B or D'
    },
    fee: {
      description: 'Is this NTRIP service a paid service? Please indicate with Y for yes or N for no.',
      content: 'Y or N'
    },
    bitrate: {
      description: 'Datarate in bits per second. For example: 4,800',
      content: 'Number'
    },
    misc: {
      description: 'Miscellaneous information.',
      content: 'Text'
    }
  };

  constructor(
    public dialogRef: MatDialogRef<MountPointPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.data && this.data.mountPoint) {
      this.selectedMountPoint = this.data.mountPoint;
    } else {
      this.loading = false;
    }
  }

  onBack(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    console.log('Form submitted:', this.selectedMountPoint);
    this.dialogRef.close();
  }

  showHelp(key: string): void {
    const helpData = this.helpData[key];
    this.dialog.open(HelpDialogComponent, {
      width: '300px',
      data: helpData
    });
  }

  currentHelp = { description: '', content: '' };

  hideHelp(): void {
    this.currentHelp = { description: '', content: '' };
  }
}